import { TableCell, TableCellProps, Theme } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

interface StyledTableCellProps extends TableCellProps {
  displayConcentrationColumn?: boolean
  isServiceColumn?: boolean
}

const StyledTableCell = withStyles((theme: Theme) => ({
  root: {
    padding: (props: StyledTableCellProps) =>
      props.displayConcentrationColumn
        ? theme.spacing(2, 2)
        : theme.spacing(3, 3),
    whiteSpace: (props) =>
      props.isServiceColumn ? ('normal' as const) : 'nowrap',
    fontSize: theme.typography.pxToRem(12),
    '&:last-child': {
      paddingRight: theme.spacing(4),
    },
  },
  head: {
    fontWeight: theme.typography.fontWeightBold,
  },
}))((props: StyledTableCellProps) => {
  return <TableCell {...props} />
})

export default StyledTableCell
